export const FETCH_BRAND_CATEGORY_DETAILS_BEGIN = 'FETCH_BRAND_CATEGORY_DETAILS_BEGIN';
export const FETCH_BRAND_CATEGORY_DETAILS_SUCCESS = 'FETCH_BRAND_CATEGORY_DETAILS_SUCCESS';
export const FETCH_BRAND_CATEGORY_DETAILS_FAILURE = 'FETCH_BRAND_CATEGORY_DETAILS_FAILURE';
export const EXPAND_CATEGORY_DETAILS = 'EXPAND_CATEGORY_DETAILS';
export const RESET_BRAND_CATEGORY_DETAILS = 'RESET_BRAND_CATEGORY_DETAILS';